export * from './ProductMiniCardsCarousel'

export type { ProductMiniCardsCarouselProps } from './ProductMiniCardsCarousel.types'
